import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditNewsletterComponent } from './edit-newsletter/edit-newsletter.component';
import { NewsletterListComponent } from './newsletter-list/newsletter-list.component';
import { AddNewsletterComponent } from './add-newsletter/add-newsletter.component';
import { featureFlagGuard } from '../core/feature-flags/feature-flag-guard';
import { Features } from '../core/feature-flags/features';

const routes: Routes = [
  {
    path: '',
    component: NewsletterListComponent,
    canActivate: [
      featureFlagGuard(Features.NEWSLETTER, false, '/cms/dashboard'),
    ],
  },
  {
    path: 'create',
    component: AddNewsletterComponent,
    canActivate: [
      featureFlagGuard(Features.NEWSLETTER, false, '/cms/dashboard'),
    ],
  },
  {
    path: ':id',
    component: EditNewsletterComponent,
    canActivate: [
      featureFlagGuard(Features.NEWSLETTER, false, '/cms/dashboard'),
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NewsletterManagementRoutingModule {}
